// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider } from './hooks/useConfig';
import { AuthProvider } from './hooks/useAuth';
import { AlertProvider } from './hooks/useAlert';
import { SocketProvider } from './hooks/SocketContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

// This is now the single place where the Router and all context providers are set up.
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ConfigProvider>
        {/* --- THE FIX --- */}
        {/* AlertProvider must be a parent of AuthProvider, because AuthProvider uses it. */}
        <AlertProvider>
          <AuthProvider>
            <SocketProvider>
              <App />
            </SocketProvider>
          </AuthProvider>
        </AlertProvider>
      </ConfigProvider>
    </BrowserRouter>
  </React.StrictMode>
);
